export default Object.freeze({
  FormField: 1,
  Variable: 2,
  IterationStepData: 3,
});
